import type { merchantsAPI } from '@backmarket/http-api'

export enum UploadTypes {
  listingsOnly = 'listing',
  listingsWithProduct = 'listing-with-product',
}

export type TransformedCategory = merchantsAPI.DocWebsiteCategory & {
  categoryLevel: number
  parentCategoryId: number
}
